import { Box, CircularProgress, Dialog, DialogContent } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shopDetails } from '../../../redux/Account/ShopDetails/action';
import { useGetShopConfig, useGetShopTaxes, useUpdateShopTaxes } from '../../../services/core/settings';
import { useGetvisibilitySetting, useUpdatevisibilitySetting } from '../../../services/core/settings/settings.hooks';
import SuccessMessageModal from '../../Common/SuccessMessage';
import DiscountProgram from './DiscountProgram';
import Fees from './Fees';
import InvoiceSettings from './InvoiceSettings';
import InvoiceVisibility from './InvoiceVisibility';
import PublishCarfax from './PublishCarfax';
import SalesTax from './SalesTax';
import ShopCancellationPolicy from './ShopCancellationPolicy';
import ShopEstimate from './ShopEstimate';
import ShopTechniciansAndAdvisors from './ShopTechniciansAndAdvisors';
import ShopTermsAndWarranty from './ShopTermsAndWarranty';
import WorkOrderAuthorizationText from './WorkOrderAuthorizationText';

const Pricing = () => {
    const dispatch = useDispatch();
    const [showLoader] = useState(false);
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage] = useState('');
    const shopDetailsData = useSelector((state) => state?.account?.shopDetailsData);

    const updateShopTaxesMutation = useUpdateShopTaxes();

    // TanStack Query hooks
    const { data: configData, isLoading: isConfigLoading } = useGetShopConfig();
    const { data: shopTaxesData, isLoading: isShopTaxesLoading } = useGetShopTaxes();

    const { data: settingVisibility, isLoading: isSettingsvisibility } = useGetvisibilitySetting();

    const updateVisibilitySettingMutation = useUpdatevisibilitySetting();

    // Fetch shop details on component mount
    useEffect(() => {
        getShopDetails();
    }, []);

    /**
     * Fetches shop details from the server via Redux action
     */
    const getShopDetails = async () => {
        await dispatch(shopDetails());
    };

    return (
        <>
            <Box>
                <InvoiceSettings
                    settingVisibility={settingVisibility}
                    isUpdating={updateVisibilitySettingMutation.isPending}
                    configData={configData}
                    shopDetailsData={shopDetailsData}
                />
                <InvoiceVisibility settingVisibility={settingVisibility} updateVisibilitySettingMutation={updateVisibilitySettingMutation} />
                {configData?.config?.carfaxSettings?.dailyROUploadEnabled && <PublishCarfax configData={configData} />}
                <SalesTax
                    shopDetails={shopDetailsData}
                    shopTaxesData={shopTaxesData}
                    isShopTaxesLoading={isShopTaxesLoading}
                    updateShopTaxesMutation={updateShopTaxesMutation}
                />
                <Fees getShopDetails={getShopDetails} type="invoice" />
                <ShopTechniciansAndAdvisors />
                <ShopTermsAndWarranty getShopDetails={getShopDetails} />
                <WorkOrderAuthorizationText />
                <DiscountProgram getShopDetails={getShopDetails} />
                <ShopEstimate getShopDetails={getShopDetails} />
                <ShopCancellationPolicy getShopDetails={getShopDetails} />

                <Dialog
                    fullScreen={false}
                    open={
                        showLoader ||
                        isConfigLoading ||
                        isSettingsvisibility ||
                        isShopTaxesLoading ||
                        updateShopTaxesMutation.isPending ||
                        updateVisibilitySettingMutation.isPending
                    }
                >
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
                <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />
            </Box>
        </>
    );
};

export default Pricing;
